/**
 * Deep links into the scheduling surface.
 *
 * Creating an appointment had no URL of its own -- it was only reachable by pressing
 * "New Appointment" in the schedule header -- so this flag lets other parts of the app
 * send a clinician straight into the create drawer (the appointment overlay's
 * follow-up task uses it). ScheduleGrid consumes the flag and strips it once open.
 *
 * Pointing it at the patient's own appointments tab is what preselects them:
 * AppointmentScheduler reads `patientId` from the route and prefills the patient
 * field from it.
 */

export const NEW_APPOINTMENT_PARAM = "new";

export const patientAppointmentsPathFor = (patientId: string) =>
  `/patients/${patientId}/appointments`;

export const newAppointmentPath = (patientId: string) =>
  `${patientAppointmentsPathFor(patientId)}?${NEW_APPOINTMENT_PARAM}=1`;
